// fileName must match a file in src/images/publication
const publicationsData = [
  {
    id: "pub-frenzel-excerpt",
    fileName: "auszug aus Buch_Eric_Frenzel.pdf",
    title: {
      de: '"Skispitzen- die schönsten Kolumnen des Olympiasiegers" (Auszug)',
      en: '"Skispitzen – the finest columns of the Olympic champion" (excerpt)',
      fr: "« Skispitzen – les plus belles chroniques du champion olympique » (extrait)",
      es: "« Skispitzen – las mejores columnas del campeón olímpico » (extracto)",
    },
    subtitle: {
      de: "Eric Frenzel/Stephan Peplies",
      en: "Eric Frenzel/Stephan Peplies",
      fr: "Eric Frenzel/Stephan Peplies",
      es: "Eric Frenzel/Stephan Peplies",
    },
    isbn: "978-3-9824733-0-7",
  },
  {
    id: "pub-frenzel-skispitzen-interview",
    fileName: "Eric Frenzel_Stephan Peplies_ Skispitzen_Interview.pdf",
    title: {
      de: '"Skispitzen – die schönsten Kolumnen des Olympiasiegers" (Interview)',
      en: '"Skispitzen – the finest columns of the Olympic champion" (interview)',
      fr: "« Skispitzen – les plus belles chroniques du champion olympique » (interview)",
      es: "« Skispitzen – las mejores columnas del campeón olímpico » (entrevista)",
    },
    subtitle: {
      de: "Eric Frenzel/Stephan Peplies",
      en: "Eric Frenzel/Stephan Peplies",
      fr: "Eric Frenzel/Stephan Peplies",
      es: "Eric Frenzel/Stephan Peplies",
    },
    isbn: "978-3-9824733-0-7",
  },
  {
    id: "pub-sieger-maschen",
    fileName: "Sieger Maschen_auszug.pdf",
    title: {
      de: '"Siegermaschen- Stricken mit Magdalena Neuner" (Auszug)',
      en: '"Siegermaschen – knitting with Magdalena Neuner" (excerpt)',
      fr: "« Siegermaschen – tricoter avec Magdalena Neuner » (extrait)",
      es: "« Siegermaschen – tejer con Magdalena Neuner » (extracto)",
    },
    subtitle: {
      de: "Lana Grossa/Magdalena Neuner",
      en: "Lana Grossa/Magdalena Neuner",
      fr: "Lana Grossa/Magdalena Neuner",
      es: "Lana Grossa/Magdalena Neuner",
    },
    isbn: "978-3-7724-6730-1",
  },
]

export default publicationsData
